import { render } from "./Integrations.vue?vue&type=template&id=73cf1c9f"
import script from "./Integrations.vue?vue&type=script&lang=js"
export * from "./Integrations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/Modules/Integrations/Integrations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73cf1c9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73cf1c9f', __exports__)) {
    api.reload('73cf1c9f', __exports__)
  }
  
  module.hot.accept("./Integrations.vue?vue&type=template&id=73cf1c9f", () => {
    api.rerender('73cf1c9f', render)
  })

}


export default __exports__